module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n        Landing Page Settings\n      ")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3 mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Background Image")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "x2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "x3": ""
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.styles.landing.background_image,
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": "",
      "raised": ""
    },
    on: {
      "click": function($event) {
        return _vm.selectFile('fileInput-bg')
      }
    }
  }, [_vm._v("Change Image")]), _vm._v(" "), _c('input', {
    ref: "fileInput-bg",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "background_image"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x9": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Background Color")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Background Color"
    },
    model: {
      value: (_vm.styles.landing.background_color),
      callback: function($$v) {
        _vm.$set(_vm.styles.landing, "background_color", $$v)
      },
      expression: "styles.landing.background_color"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styles.landing.background_color),
      expression: "styles.landing.background_color"
    }],
    ref: "fileColor",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.styles.landing.background_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.styles.landing, "background_color", $event.target.value)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Font Types")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "items": _vm.font_types,
      "label": "Select",
      "item-value": "text"
    },
    model: {
      value: (_vm.font_type),
      callback: function($$v) {
        _vm.font_type = $$v
      },
      expression: "font_type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-left pl-4",
    attrs: {
      "xs3": "",
      "offset-xs3": "",
      "justify-start": true
    }
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              Save\n              "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d075b73","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Appearance/landing.vue
// module id = 1232
// module chunks = 2 9